import { Bar } from "react-chartjs-2";
import { useGetGeoBimDownloadsFullQuery } from "../../services/API/statisticsAPI";
import { useTranslation } from "react-i18next";
import ChartCard from "./ChartCard";
import CsvDownloadButton from "./CsvDownloadButton";
import exportAllExports from "./Export/exportAllExports";
import { baseOptions, monthlyScales, nullifyFutureMonths, yearBarDataset } from "./chartTheme";

const GeoBimDownloadsStats = () => {
  const { t } = useTranslation(["translation", "statistics"]);
  const todayYear = new Date().getFullYear();
  const lastYear = todayYear - 1;

  const {
    data: geobimDownloadsFullData,
    error: fullDataError,
    isLoading: fullDataLoading,
  } = useGetGeoBimDownloadsFullQuery(undefined, { pollingInterval: 60000 });

  //Aggregate by month
  const monthLabels = Array.from({ length: 12 }, (_, m) =>
    new Date(todayYear, m).toLocaleString("default", { month: "short" })
  );

  const monthlyTotals = new Array(12).fill(0);
  const monthlyTotalsLastYear = new Array(12).fill(0);

  if (Array.isArray(geobimDownloadsFullData)) {
    geobimDownloadsFullData.forEach((item) => {
      if (item?.downloadAt) {
        const d = new Date(item.downloadAt);
        const y = d.getFullYear();
        if (y === todayYear) {
          monthlyTotals[d.getMonth()] = (monthlyTotals[d.getMonth()] || 0) + 1;
        } else if (y === lastYear) {
          monthlyTotalsLastYear[d.getMonth()] = (monthlyTotalsLastYear[d.getMonth()] || 0) + 1;
        }
      }
    });
  }

  const dataGeoBimDownloads = {
    labels: monthLabels,
    datasets: [
      yearBarDataset({
        label: `${lastYear}`,
        data: monthlyTotalsLastYear,
        isCurrentYear: false,
      }),
      yearBarDataset({
        label: `${todayYear}`,
        data: nullifyFutureMonths(monthlyTotals),
        isCurrentYear: true,
      }),
    ],
  };

  const options = {
    ...baseOptions(),
    scales: monthlyScales(),
  };

  const totalDownloads = geobimDownloadsFullData?.length || 0;
  const title = t("geobim.title", { ns: "statistics" });

  if (fullDataError) {
    return (
      <ChartCard title={title}>
        <div className="alert alert-danger">
          {t("general.error_loading_data", { ns: "statistics" })}
        </div>
      </ChartCard>
    );
  }

  if (fullDataLoading) {
    return (
      <ChartCard title={title}>
        <div>{t("general.loading", { ns: "statistics" })}</div>
      </ChartCard>
    );
  }

  if (totalDownloads === 0) {
    return (
      <ChartCard title={title}>
        <div className="alert alert-info">
          {t("general.no_data_available", { ns: "statistics" })}
        </div>
      </ChartCard>
    );
  }

  return (
    <ChartCard
      title={title}
      subtitle={`${t("geobim.total_downloads", { ns: "statistics" })}: ${totalDownloads}`}
      action={
        <CsvDownloadButton
          data={exportAllExports.geobimDownloadsFull(geobimDownloadsFullData ?? [])}
          headers={exportAllExports.geobimDownloadsHeadersFull()}
          filename={"stats_geobim_downloads.csv"}
        />
      }
    >
      <Bar options={options} data={dataGeoBimDownloads} />
    </ChartCard>
  );
};

export default GeoBimDownloadsStats;
